import React from 'react';
import DropDownSelect from './DropDownSelect';

const LocationSelect = props => {
    const { location, facility, court, loading, locations, facilities, courts, onLocationChange, onFacilityChange, onCourtChange } = props;
    return (
        <div className={`form-group form-group-xl`}>
            <DropDownSelect
                label={'Location'}
                value={location}
                onChange={onLocationChange}
                options={locations}
                defaultOption={{ value: '', text: 'Choose location...' }}
                loading={loading}
            />
            <DropDownSelect
                label={'Facility'}
                labelClass={'mt16'}
                value={facility}
                onChange={onFacilityChange}
                options={facilities}
                defaultOption={{ value: '', text: 'Choose facility...' }}
                loading={loading}
            />
            <DropDownSelect
                label={'Court'}
                labelClass={'mt16'}
                value={court}
                onChange={onCourtChange}
                options={courts}
                defaultOption={{ value: '', text: 'Choose court...' }}
                loading={loading}
            />
        </div>
    );
};

export default LocationSelect;
